module.exports = __webpack_public_path__ + "static/media/verification.65cc4e1e.svg";